'use strict';

angular.module('shared.productCardCarousel', []);